import { Component } from '@angular/core';

@Component({
  selector: 'app-steps-data-empty',
  templateUrl: './steps-data-empty.component.html',
  styleUrls: ['./steps-data-empty.component.scss']
})
export class StepsDataEmptyComponent {

}
